export enum WorksheetColumns {
    none = 0,
    toDo = 1,
    responsible = 2,
    contacttill = 3,
    solution = 4,
}
